/**
 * Runtime feature flags.
 *
 * Kept as a plain module (not env-driven) so the whole flag state is visible
 * in-tree — no hidden .env divergence between local and production. To ship
 * a flag change, edit here and deploy.
 *
 * Guidance (Feb 2026, user direction):
 *   "Temporarily remove or disable all RemodDash promotional pop-ups,
 *    onboarding prompts, and cross-promotions. The focus of this phase is
 *    making Zita a complete, polished product. Design the architecture so
 *    RemodDash integration can be enabled later without major changes, but
 *    do not surface it in the UI yet."
 */
export const FEATURES = {
  // Master switch for all RemodDash cross-promo surfaces:
  //   • The post-login RemoddashPromo modal
  //   • The AppShell sidebar "Business Tools · RemodDash" link
  //   • The Settings page Business Tools section
  //   • Any future contextual Ari suggestion pointing at RMD
  //
  // Set to true once Zita has enough usage to teach us where RMD naturally
  // belongs in the flow. Until then, Zita reads as a finished product on
  // its own.
  remoddashPromo: false,
};

export default FEATURES;
